@if (layout == GalleryLayout.CAROUSEL_PLAY) {
  <div class="carousel_play">
    @if (showButtonAutoPlay) {
      <div>
        @if (carouselPlayInterval) {
          <button class="btn-show-button-auto-play"
            (click)="startPlayCarousel()"
            attr.aria-label="{{'Disable carousel auto play'|translate}}">
            <i class="material-icons align-middle">pause_circle_outline</i>
            <i class="fa fa-pause d-none"></i>
          </button>
        }
        @if (!carouselPlayInterval) {
          <button class="btn-show-button-auto-play"
            (click)="startPlayCarousel()"
            attr.aria-label="{{'Enable carousel auto play'|translate}}">
            <i class="material-icons align-middle">play_circle_outline</i>
            <i class="fa fa-play d-none"></i>
          </button>
        }
      </div>
    }
    <carousel [interval]="carouselPlayInterval">
      @for (item of galleryItems; track item) {
        <slide class="carousel_play_item">
          @if (item.type === GalleryItemType.IMAGE) {
            <div class="carousel-img-wrap" >
              @if (!showOriginalSize) {
                <img [src]="CDNPrefix + item.poster" [alt]="item.title |translate"
                  loading="lazy"/>
              }
              @if (showOriginalSize) {
                <img class="mw-100" [src]="CDNPrefix + item.src" [alt]="item.alternative |translate"
                  loading="lazy"/>
              }
              <div [ngClass]="gridInfo['addCaptionStyles']?'flat-mode-caption':'carousel-caption'">
                @if (!hideTitle && item.title) {
                  @switch (headingLevel) {
                    @case (2) {
                      <h2 class="h5-title">{{item.title}}</h2>
                    }
                    @case (3) {
                      <h3 class="h5-title">{{item.title}}</h3>
                    }
                    @case (4) {
                      <h4 class="h5-title">{{item.title}}</h4>
                    }
                    @case (5) {
                      <h5 class="h5-title">{{item.title}}</h5>
                    }
                    @case (6) {
                      <h6 class="h5-title">{{item.title}}</h6>
                    }
                    @default {
                      <div class="h5-title">{{item.title}}</div>
                    }
                  }
                }
                @if (!hideDescription  && item.description) {
                  <span>{{item.description}}</span>
                }
                @if (subTitle  && item.subTitle) {
                  <span class="sub-title" [attr.aria-label]="item.title">{{item.subTitle}}</span>
                }
              </div>
            </div>
          }
          @if (item.type === GalleryItemType.YOU_TUBE) {
            <div class="carousel-img-wrap">
              <iframe width="560" height="315" [src]="item.src | safe: 'resourceUrl'"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
            </div>
          }
          @if (item.type === GalleryItemType.VIDEO) {
            <div class="carousel-img-wrap">
              <video width="100%" [src]="item.file_path + '/' + item.filename"
                [autoplay]="entityConfig?.video && entityConfig.video.autoplay !== undefined ? entityConfig.video.autoplay : true"
                [loop]="entityConfig?.video && entityConfig.video.loop !== undefined ? entityConfig.video.loop : true"
                [muted]="entityConfig?.video && entityConfig.video.muted !== undefined ? entityConfig.video.muted : true"
                [controls]="entityConfig?.video && entityConfig.video.controls!== undefined ? entityConfig.video.controls : true"
              type="video/mp4"></video>
            </div>
          }
        </slide>
      }
      @if (noImagePic && !galleryItems?.length) {
        <img class="no-image-pic" [src]="CDNPrefix + noImagePic" [alt]="'No Image' |translate" loading="lazy"/>
      }
    </carousel>
  </div>
}
@if (layout == GalleryLayout.CAROUSEL || layout == GalleryLayout.PREVIEW_CAROUSEL) {
  <div [ngClass]="{'mobile': (sharedSvc.isMobileMode$ | async)}" class="gallery-layout">
    <div [id]="galleryId" [ngClass]="key" #carousel class="carousel slide my-carousel" data-bs-interval="false">
      <div class="carousel-inner">
        @for (array of carouselArray; track array; let i = $index; let first = $first) {
          <div class="carousel-item"
            [ngClass]="{'active' : first}" attr.data-slide-number="{{i}}">
            <div class="d-flex justify-content-center">
              @for (item of carouselArray[i]; track item; let j = $index) {
                <div (click)="open(content, i, j)">
                  @if (item.type === GalleryItemType.IMAGE) {
                    <!--<div class="carousel-img-wrap" (click)="open(i)" >-->
                    <div class="carousel-img-wrap" >
                      @if (first && popular) {
                        <img class="popular-img" [src]="CDNPrefix + '/images/Fittings/' + systemName +'/field_images/popular/popular_' + popular + '_Big.png'" loading="lazy"/>
                      }
                      @if (!showOriginalSize) {
                        <img [src]="CDNPrefix + item.poster" [alt]="item.title |translate"
                          loading="lazy"/>
                      }
                      @if (showOriginalSize) {
                        <img class="mw-100" [src]="CDNPrefix + item.src" [alt]="item.alternative |translate"
                          loading="lazy"/>
                      }
                      <div [ngClass]="gridInfo['addCaptionStyles']?'flat-mode-caption':'carousel-caption'">
                        @if (!hideTitle && item.title) {
                          @switch (headingLevel) {
                            @case (2) {
                              <h2 class="h5-title">{{item.title}}</h2>
                            }
                            @case (3) {
                              <h3 class="h5-title">{{item.title}}</h3>
                            }
                            @case (4) {
                              <h4 class="h5-title">{{item.title}}</h4>
                            }
                            @case (5) {
                              <h5 class="h5-title">{{item.title}}</h5>
                            }
                            @case (6) {
                              <h6 class="h5-title">{{item.title}}</h6>
                            }
                            @default {
                              <div class="h5-title">{{item.title}}</div>
                            }
                          }
                        }
                        @if (!hideDescription  && item.description) {
                          <span>{{item.description}}</span>
                        }
                        @if (subTitle  && item.subTitle) {
                          <span class="sub-title" [attr.aria-label]="item.title">{{item.subTitle}}</span>
                        }
                      </div>
                    </div>
                  }
                  @if (item.type === GalleryItemType.YOU_TUBE) {
                    <div class="carousel-img-wrap">
                      <iframe width="560" height="315" [src]="item.src | safe: 'resourceUrl'"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen></iframe>
                    </div>
                  }
                  @if (item.type === GalleryItemType.VIDEO) {
                    <div class="carousel-img-wrap">
                      <video width="100%" [src]="item.file_path + '/' + item.filename"
                        [autoplay]="entityConfig?.video && entityConfig.video.autoplay !== undefined ? entityConfig.video.autoplay : true"
                        [loop]="entityConfig?.video && entityConfig.video.loop !== undefined ? entityConfig.video.loop : true"
                        [muted]="entityConfig?.video && entityConfig.video.muted !== undefined ? entityConfig.video.muted : true"
                        [controls]="entityConfig?.video && entityConfig.video.controls!== undefined ? entityConfig.video.controls : true"
                      type="video/mp4"></video>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
        @if (noImagePic && !carouselArray?.length) {
          <img class="no-image-pic" [src]="CDNPrefix + noImagePic" [alt]="'No Image' |translate" loading="lazy"/>
        }
        @if (galleryItems && galleryItems.length > 1) {
          <a class="carousel-control-prev" [href]="'#' + galleryId" role="button" data-bs-slide="prev"  [attr.data-bs-target]="'#' + galleryId">
            <i class="fas fa-chevron-left" style="font-size:24px"></i>
            <span class="sr-only">Previous</span>
          </a>
        }
        @if (galleryItems && galleryItems.length > 1) {
          <a class="carousel-control-next" [href]="'#' + galleryId" role="button" data-bs-slide="next" [attr.data-bs-target]="'#' + galleryId">
            <span class="sr-only">Next</span>
            <i class="fas fa-chevron-right" style="font-size:24px"></i>
          </a>
        }
      </div>
      @if (!hideIndicator || layout == GalleryLayout.PREVIEW_CAROUSEL) {
        <div class="control-indicators">
          @if (galleryItems && calculateToShowIndicator()) {
            <div class="carousel-control-indicators-next" (click)="scrollTo('next')"></div>
          }
          <ol class="carousel-indicators list-inline px-0">
            @for (item of galleryItems; track item; let idx = $index; let first = $first) {
              <li id="li-carousel-selector-{{idx}}" [ngClass]="{'active' : first }"
                class="list-inline-item m-0">
                <a id="carousel-selector-{{idx}}" [ngClass]="{'select' : first}"
                  attr.data-bs-slide-to="{{idx}}" attr.data-bs-target="#{{galleryId}}">
                  <img [src]="CDNPrefix + item.thumb" [alt]="item.title |translate" loading="lazy"/>
                </a>
              </li>
            }
          </ol>
          @if (galleryItems && showIndicatorByWidth) {
            <div class="carousel-control-indicators-prev" (click)="scrollTo('prev')"></div>
          }
        </div>
      }
    </div>
  </div>
}
@if (layout == GalleryLayout.ALTCAROUSEL) {
  <div [id]="galleryId" [ngClass]="key" class="position-relative gallery-layout alt-carousel">
    <div class=" carousel-inner d-flex align-items-baseline hide-scrollbar" style="width: auto; overflow: auto; scroll-behavior: smooth;" #altCarouselContainer>
      @for (item of galleryItems; track item; let index = $index) {
        <div
          class="text-center flex-grow-0 flex-shrink-0 carousel-img-wrap"
          [ngClass]="index == activeIndex || index == activeIndex+1 ? 'swiper-slide-active':''"
                 [ngStyle]="{
                            'width' : carouselItemsWidth,
                            'margin-top': gridInfo['gutterVertical'],
                            'margin-bottom': gridInfo['gutterVertical'],
                            'margin-right': gridInfo['gutterHorizontal'],
                            'margin-left': gridInfo['gutterHorizontal']}"
          >
          <a class="gallery-link" [routerLink]="[item.link? item.link :'']" (click)="routerNavigate(item.link,$event)">
            <img   [src]="CDNPrefix + item.src" [alt]="item.alternative ? (item.alternative |translate): '' " loading="lazy">
            <div [ngClass]="gridInfo['addCaptionStyles']?'flat-mode-caption':'carousel-caption'">
              @if (!hideTitle && item.title) {
                @switch (headingLevel) {
                  @case (2) {
                    <h2  class="h5-title">{{item.title}}</h2>
                  }
                  @case (3) {
                    <h3  class="h5-title">{{item.title}}</h3>
                  }
                  @case (4) {
                    <h4  class="h5-title">{{item.title}}</h4>
                  }
                  @case (5) {
                    <h5  class="h5-title">{{item.title}}</h5>
                  }
                  @case (6) {
                    <h6  class="h5-title">{{item.title}}</h6>
                  }
                  @default {
                    <div  class="h5-title">{{item.title}}</div>
                  }
                }
              }
              @if (!hideDescription  && item.description) {
                <span>{{item.description}}</span>
              }
              @if (subTitle  && item.subTitle) {
                <span class="sub-title" [attr.aria-label]="item.title">{{item.subTitle}}</span>
              }
            </div>
          </a>
        </div>
      }
      @if (noImagePic && !galleryItems?.length) {
        <img class="no-image-pic" [src]="CDNPrefix + noImagePic" [alt]="'No Image' |translate" loading="lazy"/>
      }
    </div>
    @if (showCarouselButtons) {
      <button type="button" class="carousel-control-prev btn" (click)="scrollAltCarousel('left')" attr.aria-label="{{'prev-carousel' | translate}}" style="position: absolute; right:86vw; left: 0; top: 50%; transform: translateY(-50%)" tabindex="-1" ><span> > </span></button>
      <button type="button" class="carousel-control-next btn" (click)="scrollAltCarousel('right')" attr.aria-label="{{'next-carousel' | translate}}" style="position: absolute; right: 0; top: 50%; transform: translateY(-50%)" tabindex="-1" ><span> < </span></button>
    }
  </div>
}
@if (layout == GalleryLayout.FLAT) {
  <div class="gallery-layout"
    [ngStyle]="{'padding-right': gridInfo['gutterHorizontal'], 'padding-left': gridInfo['gutterHorizontal']}">
    <ul [ngClass]="key" class="list-unstyled px-0 row row-cols-{{gridInfo['itemsPerRow']}} justify-content-{{gridInfo['justifyContent']}}"
      [ngStyle]="{'margin-right': '-'+(gridInfo['gutterHorizontal']), 'margin-left': '-'+(gridInfo['gutterHorizontal'])}">
      @for (item of galleryItems; track item; let i = $index; let first = $first) {
        <li
          [ngClass]="{'active' : first , 'col' : gridInfo['itemsPerRow'], 'col-auto' : !gridInfo['itemsPerRow']}"
          [ngStyle]="{'padding': gridInfo['gutterHorizontal']+' '+ gridInfo['gutterVertical']}">
          @if (item.type === GalleryItemType.IMAGE) {
            <div class="carousel-img-wrap" >
              <a [attr.item-key]="item.gridArea" class="gallery-link" [href]="item.link" (click)="routerNavigate(item.link, $event, item, image)" role="presentation">
                <img [ngClass]="gridInfo['itemsPerRow'] ? 'w-100' : ''" [src]="CDNPrefix + item.src" role="button" [alt]="item.alternative |translate"
                  loading="lazy"/>
                <div [ngClass]="gridInfo['addCaptionStyles']?'flat-mode-caption':'carousel-caption'">
                  @if (!hideTitle && item.title) {
                    @switch (headingLevel) {
                      @case (2) {
                        <h2  class="h5-title">{{item.title}}</h2>
                      }
                      @case (3) {
                        <h3  class="h5-title">{{item.title}}</h3>
                      }
                      @case (4) {
                        <h4  class="h5-title">{{item.title}}</h4>
                      }
                      @case (5) {
                        <h5  class="h5-title">{{item.title}}</h5>
                      }
                      @case (6) {
                        <h6  class="h5-title">{{item.title}}</h6>
                      }
                      @default {
                        <div  class="h5-title">{{item.title}}</div>
                      }
                    }
                  }
                  @if (!hideDescription  && item.description) {
                    <span class="description-gallery">{{item.description}}</span>
                  }
                  @if (subTitle  && item.subTitle) {
                    <span class="sub-title" [attr.aria-label]="item.title">{{item.subTitle}}</span>
                  }
                </div>
              </a>
              <!--                        <div class="carousel-caption" *ngIf="item.description">{{item.description}}</div>-->
            </div>
          }
          @if (item.type === GalleryItemType.YOU_TUBE) {
            <div class="carousel-img-wrap">
              <iframe width="560" height="315" [src]="item.src | safe: 'resourceUrl'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              @if (!hideDescription  && item.description) {
                <span class="description-gallery">{{item.description}}</span>
              }
              @if (subTitle  && item.subTitle) {
                <span class="sub-title" [attr.aria-label]="item.title">{{item.subTitle}}</span>
              }
            </div>
          }
        </li>
      }
      @if (noImagePic && !galleryItems?.length) {
        <img class="no-image-pic" [src]="CDNPrefix + noImagePic" [alt]="'No Image' |translate" loading="lazy"/>
      }
    </ul>
  </div>
}

<ng-template #image let-modal>
  <img [ngClass]="gridInfo['itemsPerRow'] ? 'w-100' : ''" [src]="CDNPrefix + showImage.src" [alt]="showImage.alternative |translate" loading="lazy"/>
</ng-template>

@if (layout == GalleryLayout.PUZZLE) {
  <div [ngClass]="key" class="row gallery-layout">
    <div class="gallery-puzzle" [attr.count-items]="sharedSvc.isMobileMode() ? carouselMobileItems : carouselItems">
      @for (item of galleryItems; track item; let i = $index; let first = $first) {
        @if (item.type === GalleryItemType.IMAGE) {
          <div class="position-relative gallery__item gallery__item--{{item.gridArea}}">
            <a class="gallery-link" [routerLink]="[]" (click)="routerNavigate(item.link,$event)">
              <div class="gallery-img"
                [ngStyle]="{'background-image': 'url('+item.src+')'}">
              </div>
              <div class="carousel-caption">
                @if (!hideTitle && item.title) {
                  <h3  class="gallery-title"
                    title="{{item.title}}">
                    {{item.title}}
                  </h3>
                }
                @if (!hideDescription  && item.description) {
                  <h4 class="gallery-subtitle" title="{{item.description}}">
                    {{item.description}}
                  </h4>
                }
              </div>
            </a>
          </div>
        }
      }
      @if (noImagePic && !galleryItems?.length) {
        <img class="no-image-pic" [src]="CDNPrefix + noImagePic" [alt]="'No Image' |translate" loading="lazy"/>
      }
    </div>
  </div>
}


<ng-template #content let-modal>
  <div class="pt-3 pr-3 pl-3 " >
    <button type="button" class="close float-right" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span class="d-inline-block" aria-hidden="true">&times;</span>
    </button>
  </div>
  <!--[ngClass]="{'mobile-mode': shareSvc.isMobileMode()}"-->
  <div [ngClass]="{'mobile': (sharedSvc.isMobileMode$ | async)}" >
    <div class="modal-body gallery-layout">
      <div class="container">
        <div class=" align-items-center">
          <div class="" id="slider-{{galleryId}}">
            <div [id]="'popup' + galleryId" #carousel class="carousel slide" data-bs-interval="false">
              <div class="carousel-inner">
                @for (item of galleryItems; track item; let i = $index; let first = $first) {
                  <div class="carousel-item" [ngClass]="{'active' : i == indexStart}" attr.data-slide-number="{{i}}" >
                    <div>
                      @if (item.type === GalleryItemType.IMAGE && !item.entityBlock ) {
                        <div class="carousel-img-wrap" >
                          <img class="img-fluid" [src]="CDNPrefix + (CDNPrefix ? item.src : item.modal)" [alt]="item.alternative |translate" loading="lazy"/>
                          @if (!hideDescription  && item.description) {
                            <div class="carousel-caption">{{item.description}}</div>
                          }
                        </div>
                      }
                      @if (item.type === GalleryItemType.YOU_TUBE) {
                        <div class="carousel-img-wrap">
                          <iframe width="560" height="315" [src]="item.src | safe: 'resourceUrl'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                      }
                      @if (item.type === GalleryItemType.IMAGE && item.entityBlock) {
                        <div class="carousel-img-wrap">
                          <ngx-entity-block [entityVar]="item.entityBlock"></ngx-entity-block>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (noImagePic && !galleryItems?.length) {
                  <img class="no-image-pic" [src]="CDNPrefix + noImagePic" [alt]="'No Image' |translate" loading="lazy"/>
                }
                <a class="carousel-control-prev" [href]="'#popup' + galleryId" role="button" data-bs-slide="prev">
                  <i class="fas fa-chevron-left" style="font-size:24px"></i>
                  <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" [href]="'#popup' + galleryId" role="button" data-bs-slide="next">
                  <span class="sr-only">Next</span>
                  <i class="fas fa-chevron-right" style="font-size:24px"></i>
                </a>

              </div>
            </div>
          </div>

        </div>
      </div>


    </div>
    <!--<div class="text-center pb-3">-->
    <!--<button type="button" class="btn" (click)="checkImage();" id="btnSelect" translate>select {{key}}</button>-->
  <!--</div>-->
</div>
</ng-template>


@if (layout == GalleryLayout.LIBRARY) {
  <div class="gallery-outer gallery-layout" dir="ltr">
    <div class="gallery-wrapper">
      @for (item of galleryItems; track item; let i = $index) {
        <div class="gallery-item-wrapper"
          [ngStyle]="{'z-index':(galleryItems.length - Math.abs(libraryIndex - i)),'transform':'scale3d(' + (1 - (0.3 / galleryItems.length ) * Math.abs(libraryIndex - i)) + ', ' + (1 - (0.3 / galleryItems.length ) * Math.abs(libraryIndex - i)) + ', 1)'}"
          [ngClass]="{'gallery-active-item': i == libraryIndex}">
          <div (touchmove)="galleryHover(i)" (mouseover)="galleryHover(i)" class="gallery-div gallery-div-wrapper1">
            <div class="gallery-div gallery-div-wrapper2">
              <div class="gallery-div gallery-div-wrapper3">
                <div class="gallery-div gallery-div-wrapper4">
                  <div class="gallery-div-wrapper5 gallery-link-wrapper">
                    <a class="gallery-link" [routerLink]="[]" (click)="routerNavigate(item.link,$event)">
                      <div>
                        <div class="gallery-img-wrapper">
                          <div class="gallery-img"
                            [ngStyle]="{'background-image': 'url('+item.src+')'}">
                          </div>
                        </div>
                        <div  class="gallery-text-wrapper">
                          @if (!hideTitle  && item.title) {
                            <h3 class="gallery-title"
                              title="{{item.title}}">
                              {{item.title}}
                            </h3>
                          }
                          @if (!hideDescription  && item.description) {
                            <h4 class="gallery-subtitle" title="{{item.description}}">
                              {{item.description}}
                            </h4>
                          }
                        </div>
                      </div>
                      <div class="gallery-opacity-div"
                      [ngStyle]="{'opacity': ((0.6 / galleryItems.length) * Math.abs(libraryIndex - i))}"></div>
                      <div class="gallery-space"></div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      @if (noImagePic && !galleryItems?.length) {
        <img class="no-image-pic" [src]="CDNPrefix + noImagePic" loading="lazy"/>
      }
    </div>
  </div>
}
